import { Box } from "@mui/material";
import { ContainerPreviewDocument } from "./styles";
import { FolderSimple } from "@phosphor-icons/react";
// import { ModalDelete } from "./modal-delete";
import { useState } from "react";
import { Button } from "../button/button";
import { NormalText } from "../styles";

export const PreviewFile = ({
  file,
  alt = "document",
  id,
  handleRemoveFile,
  sectionFile = "",
}) => {
  const [showModalDelete, setShowModalDelete] = useState(false);

  const fileSizeInMB = (file?.size / (1024 * 1024))?.toFixed(2);

  function handleDownloadDocument() {
    if (file && file.url) {
      const link = document.createElement("a");
      link.href = file.url;
      link.download = file.name || "download";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  //   function handleShowModalDelete() {
  //     setShowModalDelete((prev) => !prev);
  //   }

  function isImageFile(fileExtension) {
    return /^(jpg|jpeg|png)$/i.test(fileExtension);
  }

  //   function handleClose() {
  //     setShowModalDelete(false);
  //   }
  const isImage = isImageFile(file?.type);

  return (
    <>
      {/* {showModalDelete && (
        <ModalDelete
          fileName={file?.name}
          id={id}
          onDelete={handleRemoveFile}
          sectionFile={sectionFile}
          handleClose={handleClose}
        />
      )} */}
      <ContainerPreviewDocument isImage={isImage}>
        {isImage ? (
          <img
            src={file.url}
            alt={alt}
            style={{
              width: "100%",
              borderRadius: "8px",
              maxWidth: "400px",
            }}
          />
        ) : (
          <Box
            display={"flex"}
            gap={"8px"}
            padding={"0 8px"}
            alignItems={"flex-start"}
            borderBottom={"1px solid #D9D9D9"}
            color={"#0F110C"}
          >
            <FolderSimple
              size={32}
              fill={"#8C8C8C"}
              weight="light"
              style={{ marginTop: "8px" }}
            />
            <Box
              display={"flex"}
              flexDirection={"column"}
              padding={"8px 0"}
              gap={"4px"}
            >
              <NormalText>{file?.name}</NormalText>
              <NormalText>{fileSizeInMB} MB</NormalText>
            </Box>
          </Box>
        )}
        <Box display={"flex"} gap={"4px"} mt={isImage ? "8px" : 0}>
          <Button
            startIcon={"Download"}
            onClick={handleDownloadDocument}
            type="regular"
            tooltipLabel={"Download"}
          />
          <Button
            startIcon={"Trash"}
            onClick={handleRemoveFile}
            type="regular"
            tooltipLabel={"Delete"}
          />
        </Box>
      </ContainerPreviewDocument>
    </>
  );
};
